import type { DataSource } from "./types";
import { httpSource } from "./httpSource";
import { staticSource } from "./staticSource";

// The active data source. Set once by the route root — <ConsoleRoot> installs
// the HTTP source, <DevRoot> installs the static one — and read by every store.
// Components and stores never import a concrete source directly.
let active: DataSource = httpSource;

export function getDataSource(): DataSource {
  return active;
}

export function setDataSource(source: DataSource): void {
  active = source;
}

export { httpSource, staticSource };
export type { DataSource } from "./types";
export { STATIC_BACKED } from "./types";
